import React from 'react';
import { portfolioData } from '../data/portfolio';

const About = () => {
  const { profile, skills } = portfolioData;

  return (
    <section id="about" className="py-20 md:py-32 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">About Me</h2>
          <div className="w-20 h-1 bg-[#00b4d8]"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-16">
          <div>
            <p className="text-lg text-[#a0a0a0] whitespace-pre-line leading-relaxed mb-6">
              {profile.bio}
            </p>
            {/* <div className="space-y-2 text-[#a0a0a0]">
              <p>
                <span className="text-white font-medium">Location:</span> {profile.location}
              </p>
              <p>
                <span className="text-white font-medium">Email:</span>{' '}
                <a href={`mailto:${profile.email}`} className="text-[#00b4d8] hover:underline">
                  {profile.email}
                </a>
              </p>
            </div> */}
          </div>

          <div>
            <h3 className="text-2xl font-semibold mb-6">Core Skills</h3>
            <div className="grid grid-cols-2 gap-3">
              {skills.map((skill, index) => (
                <div
                  key={index}
                  className="bg-[#151515] border border-white/10 px-4 py-3 rounded-lg text-[#a0a0a0]"
                >
                  {skill}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
